<template>
  <div class="wrap">
    <top-menu class="menus" v-on="$listeners" v-bind="$attrs"></top-menu>
    <div class="main">
      <el-tabs class="tabs" v-model="editableTabsValue" type="card" :addable="false" :closable="closable" :editable="editable" @tab-click="tabClick" @tab-remove="removeTab">
        <el-tab-pane :key="index" v-for="(item, index) in editableTabs" :label="item.title" :name="item.name"></el-tab-pane>
      </el-tabs>
      <div class="main-content"><router-view /></div>
    </div>
  </div>
</template>

<script>
import TopMenu from './topMenu';
import S  from '@/utils/website'
import USERAPI from '@/api/user';
export default {
  name:'Main',
  components: {
    'top-menu': TopMenu
  },
  props: {},
  data() {
    return {
      editable: true,
      closable: true,
      editableTabsValue: '2',
      editableTabs: [
        {
          title: '首页',
          name: 'Home'
        }
      ]
    };
  },
  methods: {
    tabClick(v) {
      // let tab = this.COMM.getTab();
      // let query = {};
      // if(tab){
      //   tab = JSON.parse(tab);
      //   for(let i=0;i<tab.length;i++){
      //     if(tab[i].name==v.name){
      //       query = tab[i].query;
      //       break;
      //     }
      //   }
      // }
      let menuList = this.COMM.getMenuList();
      let node = this.COMM.getSelectMenuNode(v.name,menuList);
      this.selectMenu(node);
      // this.$router.push({
      //   name: v.name,
      //   // query:query
      // });
    },
    //设置跳转点
    selectMenu(item) {
      if (item.name == 'Home') {
        this.$router.push({
          name: item.name
        });
      } else {
        let params = {
          resourceId: item.resourceId
        };
        USERAPI.searchUserResources(params).then(res => {
          //设置权限
          localStorage.setItem(S.auth.ActiveAuth, JSON.stringify(res.data.data))
          this.$router.push({
            name: item.name
          });
        });
      }
    },
    //删除标签
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      this.COMM.delTab({ name: this.$route.name, title: this.$route.meta.title });
      this.$router.push({
        name: 'Home'
      });
    },
    //添加标签
    setTab() {
      let name = this.$route.name;
      let title = this.$route.meta.title;
      if (name && title) {
        this.editableTabs = this.COMM.addTab({ name: name, title: title});
      }
    }
  },
  created() {
    this.setTab();
    this.editableTabsValue = this.$route.name || 'Home';
  },
  mounted() {},
  watch: {
    $route: {
      handler: function(val, oldval) {
        this.setTab();
        this.editableTabsValue = this.$route.name;
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="scss">
.wrap {
  min-width: 600px;
  width: 100%;
  background-color: #f0f2f5;
  .menus {
    background-color: #ffffff;
  }
}
</style>
<style lang="scss">
.main {
  height: 100%;
  width: 100%;
  .tabs {
    padding: 20px;
    background-color: #ffffff;
    .el-tabs__header {
      border-bottom: 0px;
      margin: 0px;
      .el-tabs__new-tab {
        display: none;
      }
      .el-tabs__nav {
        border-bottom: 1px solid #e4e7ed;
      }
    }
    .el-tabs__content {
      // border-top: 1px solid #E4E7ED;
    }
    border-bottom: 1px solid #e4e7ed;
  }
  .main-content {
    margin: 20px;
  }

  #tab-Home {
    width: 80px;
    margin: 0px auto;
    text-align: center;
    .el-icon-close {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue